<template>
  <div>
    <vs-popup
      class="guest-list-items-popup"
      :title="'Guest list for ' + activeVenue.name + ' on ' + formatPopupDate()"
      :active.sync="showPopup"
    >
      <vs-row vs-w="12" v-if="guestListItems.length === 0">
        <vs-col vs-lg="3">
          <div>No entries on guest list</div>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col
          v-for="guestListItem in guestListItems"
          :key="guestListItem.id"
          vs-lg="6"
          vs-sm="12"
          vs-xs="12"
          class="px-1"
        >
          <vs-card>
            <div slot="header" class="flex justify-between">
              <h4>
                {{ guestListItem.fullName }}
              </h4>
              <h5>
                {{
                  GUEST_LIST_ITEM_REQUEST_STATE.nameof(
                    guestListItem.requestState
                  )
                }}
              </h5>
            </div>

            <div>
              <vs-row class="mb-4">
                <vs-col vs-lg="6">
                  <div>Number of guests: {{ guestListItem.guestCount }}</div>
                   Guests arrived: {{getArrivedCount(guestListItem)}}
                </vs-col>
                <vs-col vs-lg="6">
                  Phone number: {{ guestListItem.phoneNumber }}
                </vs-col>
              </vs-row>
     

              <vs-row>
                <vs-col vs-lg="6">Email: {{ guestListItem.email }}</vs-col>
                <vs-col vs-lg="6" class="flex justify-end">
                  <vs-chip color="primary">{{
                  getNameOfArrivalState(guestListItem)
                  }}</vs-chip>
                </vs-col>
              </vs-row>

              <vs-row class="mb-4">
                <router-link v-if="hasPermissionToEditCustomer && guestListItem.guestProfileId"
                  :to="'/crm/guest/' + guestListItem.guestProfileId"
                  target="_blank"
                >
                  View guest profile
                </router-link>
              </vs-row>

              <vs-row>
                <vs-col vs-lg="6">
                  Note:
                  <p>{{ guestListItem.note }}</p>
                </vs-col>
                <vs-col vs-lg="6" class="flex justify-end">
                  <guest-list-item-action-selector
                    v-if="
                      $AuthService.hasPermissionForActiveVenue(
                        'vp.vp.booking.handleguestarrival'
                      )
                    "
                    @guest-list-item-action-selected="
                      handleActionSelected(guestListItem, $event)
                    "
                  />
                </vs-col>
              </vs-row>
            </div>

            <div slot="footer" class="mb-10">
              <vs-row vs-justify="flex-end">
                <div class="mr-auto mt-auto">
                <p  :style="'color: lightgrey'"> <small>Added by: {{createdBy(guestListItem.createdBy.id)}} </small></p>
                 <p :style="'color: lightgrey'"> <small >{{createdDate(guestListItem.created)}} </small></p>
                </div>
                <vs-button
                  v-if="
                    $AuthService.hasPermissionForActiveVenue(
                      'vp.vp.booking.handleguestlistrequests'
                    )
                  "
                  color="success"
                  @click="handleAcceptClick(guestListItem)"
                  :disabled="
                    guestListItem.requestState !==
                    GUEST_LIST_ITEM_REQUEST_STATE.Requested
                  "
                  >Accept  </vs-button
                >
                <vs-button
                  v-if="
                    $AuthService.hasPermissionForActiveVenue(
                      'vp.vp.booking.handleguestlistrequests'
                    )
                  "
                  color="danger"
                  class="ml-2"
                  @click="handleRejectClick(guestListItem)"
                  :disabled="
                    guestListItem.requestState !==
                    GUEST_LIST_ITEM_REQUEST_STATE.Requested
                  "
                  >Reject</vs-button
                >
              </vs-row>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-popup>

    <popup-reject-guest-on-arrival
      v-if="
        $AuthService.hasPermissionForActiveVenue(
          'vp.vp.booking.handleguestlistrequests'
        )
      "
      ref="popupRejectGuestOnArrival"
      @reject-guest-on-arrival="handleReasonForArrivalRejectionGiven"
    />

       <popup-on-arrival
      v-if="
        $AuthService.hasPermissionForActiveVenue(
          'vp.vp.booking.handleguestlistrequests'
        )
      "
      ref="PopupOnArrival"
      @update-guest-arrival-count="handlePartialGuestArrival"
      
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GuestListItemActionSelector from "../components/guest-list-items/GuestListItemActionSelector.vue";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import {
  GUEST_LIST_ITEM_REQUEST_STATE,
  GUEST_LIST_ITEM_ARRIVAL_STATE,
} from "@/store/modules/marcom/data-model/guest-list-items/guest-list-item";
import PopupRejectGuestOnArrival from "./PopupRejectGuestOnArrival.vue";
import PopupOnArrival from "./PopupPartialArrival.vue";

export default {
  components: {
    GuestListItemActionSelector,
    PopupRejectGuestOnArrival,
    PopupOnArrival
  },
  data() {
    return {
      GUEST_LIST_ITEM_REQUEST_STATE,
      GUEST_LIST_ITEM_ARRIVAL_STATE,
      showPopup: false,
      showViewGuestList: false,
      date: null,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeVenueDetails: "marcom/activeVenue",
      user: "users/user",
    }),
    guestListItems() {
      return this.$store.state.marcom.guestListItems;
    },

   
  },
  methods: {
    hasPermissionToEditCustomer() {
      return this.$AuthService.hasPermission("vp.crm.guestprofiles.view");
    },
    show(date) {
      this.date = moment(date);
      this.date = moment.utc([
        this.date.year(),
        this.date.month(),
        this.date.date(),
      ]);
      this.showPopup = true;
    },
    formatPopupDate() {
      let noteMoment = moment.utc(this.date);
      if (!noteMoment.isValid) return;
      return noteMoment.format("DD-MM-YYYY");
    },
     createdBy(id){      
       if(id != "customer" &&  !this.user(id)){
         this.getUser(id)
       }
     return id == "customer" ? "Customer" : this.user(id).firstName + " " +this.user(id).lastName
 
    },
    createdDate(date){
        return moment.utc(date).format("DD-MM-YYYY HH:mm")
    },

    async getUser(id){
      await this.$store.dispatch(
          "users/" + "getUser",
          id
        );
    },

    async handleAcceptClick(guestListItem) {
      try {
        this.$vs.loading();
        guestListItem.requestState = GUEST_LIST_ITEM_REQUEST_STATE.Approved;
        await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.UpdateGuestListItem,
          guestListItem
        );

        this.$vs.notify({
          color: "success",
          title: "Guest list item accept",
          text: "Guest list item was accepted",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Guest list item accept",
          text: "Oops, something went wrong",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async handleRejectClick(guestListItem) {
      try {
        this.$vs.loading();
        guestListItem.requestState = GUEST_LIST_ITEM_REQUEST_STATE.Rejected;
        await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.UpdateGuestListItem,
          guestListItem
        );

        this.$vs.notify({
          color: "success",
          title: "Guest list item reject",
          text: "Guest list item was rejected",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Guest list item reject",
          text: "Oops, something went wrong",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async handleActionSelected(guestListItem, action) {

      if (action.value === GUEST_LIST_ITEM_ARRIVAL_STATE.PartialArrival){
        this.$refs.PopupOnArrival.show(guestListItem);

      }

      else if (action.value === GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndRejected) {
        this.$refs.popupRejectGuestOnArrival.show(guestListItem);
      } else {
        try {
          this.$vs.loading();
          guestListItem.arrivalState = action.value;
          
     
          await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.ChangeGuestListItemArrivalState,
            { guestListItem: guestListItem, rejectionNote: null }
          );
          
          if (action.value == GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndAccepted ) {
            this.updateArrivalList(guestListItem)
          }

          this.$vs.notify({
            color: "success",
            title: "Guest list item change state",
            text: "Guest list item state changed",
          });
        } catch (err) {
          console.error(err);

          this.$vs.notify({
            color: "danger",
            title: "Guest list item change state",
            text: "Oops, something went wrong",
          });
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    async handleReasonForArrivalRejectionGiven({
      guestListItem,
      rejectionNote,
    }) {
      try {
        this.$vs.loading();
        guestListItem.arrivalState =
          GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndRejected;
        await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.ChangeGuestListItemArrivalState,
          { guestListItem: guestListItem, rejectionNote: rejectionNote }
        );

        this.$vs.notify({
          color: "success",
          title: "Guest list item change state",
          text: "Guest list item state changed",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Guest list item change state",
          text: "Oops, something went wrong",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    
   async handlePartialGuestArrival({guestListItem, arrival}){     
     try {
          this.$vs.loading();
          
          const action = {value: GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndAccepted}
          if(guestListItem.arrivalState !== action.value){
           this.handleActionSelected(guestListItem, action)
          }
           arrival.arrivalId  ? await this.$store.dispatch("marcom/" + VENUE_ACTIONS.UpdateGuestListItemPartialArrival, 
          {guestListItem: guestListItem, arrival: arrival}) : await this.$store.dispatch("marcom/" + VENUE_ACTIONS.AddPartialArraival, 
          {guestListItem: guestListItem, arrival: arrival})
        
          this.$vs.notify({
            color: "success",
            title: "Guest list item change arrival count",
            text: "Guest list item partial arrival changed",
          });
        } catch (err) {
          console.error(err);

          this.$vs.notify({
            color: "danger",
            title: "Guest list item partiavl arrival",
            text: "Oops, something went wrong",
          });
        } finally {
          this.$vs.loading.close();
        }
    },
    getArrivedCount(guestListItem){

      if(guestListItem.arrivals.length == 0) {return 0}
      var arrived = 0
      guestListItem.arrivals.forEach(arrival => {
          arrived += arrival.numPeopleArrived
      });
      return arrived
     
    },
    getNameOfArrivalState(guestListItem){
      if (guestListItem.arrivals && guestListItem.arrivals.length >= 1 && this.getArrivedCount(guestListItem) != guestListItem.guestCount){
        return "Partial arrival"
      }
     return  GUEST_LIST_ITEM_ARRIVAL_STATE.nameof( guestListItem.arrivalState)
    },

    updateArrivalList(guestListItem){
   
      const guestsArrived = guestListItem.guestCount - this.getArrivedCount(guestListItem)
      if(guestListItem.guestCount > this.getArrivedCount(guestListItem)){
      this.handlePartialGuestArrival({guestListItem: guestListItem, 
                                      arrival: {numberOfGuests: guestsArrived, note:""}
                                      })

      }
    }

  }
 
};
</script>

<style lang="scss" scoped>
.guest-list-items-popup::v-deep .vs-popup {
  width: 1080px;
}
</style>
